/* eslint-disable @typescript-eslint/explicit-function-return-type */
import axios from "axios";

const token = (): string =>
  localStorage.getItem("tokens") ?? sessionStorage.getItem("tokens") ?? "";
export const getAccessToken = (): string => {
  try {
    return JSON.parse(token()).access_token;
  } catch (e) {
    return "";
  }
};

const UNAUTHORIZED_ERROR_CODE = 401;

const URL = process.env.REACT_APP_API_URL ?? "";

const baseURL = `${URL}`;

export const AxiosInstance = axios.create({
  baseURL,
  headers: {
    "Cache-Control": "no-cache",
    Authorization: `Bearer ${getAccessToken()}`,
  },
});

AxiosInstance.interceptors.request.use(
  function (config) {
    const orgId = localStorage.getItem("orgId");
    const workspaceId = localStorage.getItem("workspaceId");
    config.headers.Authorization = `Bearer ${getAccessToken()}`;
    if (orgId) {
      config.headers["org-id"] = orgId;
    }
    if (workspaceId) {
      config.headers["workspace-id"] = workspaceId;
    }
    return config;
  },
  async function (error) {
    return await Promise.reject(new Error(error));
  }
);
AxiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response) {
      if (error.response.status === UNAUTHORIZED_ERROR_CODE) {
        // Handle unauthorized error
        // authService.getAccessToken();
        // void logout();
      }
    }
    return await Promise.reject(new Error(error));
  }
);

export default AxiosInstance;
